<template>
  <div class="departmental">
    <div class="banner-wrapper">
      <img src="../assets/service/banner5.png" alt="" class="banner">
    </div>
    <div class="departmental-list">
      <h3 class="departmental-title">
        <span>院系服务</span>
      </h3>
      <ul class="list-ul">
        <li class="list-li" v-for="item in list" :key="item.id">
          <img :src="item.cover" alt="" class="list-li-logo">
          <p class="list-li-name">
            {{item.name}}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        list: [{
            id: 1,
            name: '教师教育学院',
            img: require("../assets/service/1.png"),
          },
          {
            id: 2,
            name: '教师教育学院',
            img: require("../assets/service/2.png"),
          },
          {
            id: 3,
            name: '教师教育学院',
            img: require("../assets/service/3.png"),
          },
          {
            id: 4,
            name: '教师教育学院',
            img: require("../assets/service/4.png"),
          },
          {
            id: 5,
            name: '教师教育学院',
            img: require("../assets/service/5.png"),
          },
          {
            id: 6,
            name: '教师教育学院',
            img: require("../assets/service/6.png"),
          },

        ],
      }
    },
    methods: {
      async queryListByKey() {
        let params = {
          commonCode: 'YXFW'
        }
        let resData = await Api.Home.queryListByKey(params)
        console.log(resData);
        if (JSON.stringify(resData.rows) == '[]') return;
        this.list = resData.rows;
      },
    },
    mounted() {
      this.queryListByKey();
    },
  }
</script>

<style scoped lang="less">
  .departmental {
    .banner {
      width: 100%;
      display: block;
    }

    .departmental-list {
      width: 1200px;
      margin: 44px auto 82px;
    }

    .departmental-title {
      text-align: center;
      padding: 52px 0 97px;
      margin-bottom: 40px;
    }

    .departmental-title>span {
      padding: 52px 12px 97px;
      font-size: 32px;
      color: #383838;
      background-image: url("../assets/common/title-bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .departmental-title::after {
      content: ' ';
      position: relative;
      z-index: 2;
      display: block;
      margin: 0 auto;
      width: 518px;
      height: 28px;
      top: 32px;
      background-image: url("../assets/common/title-bottom.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .list-ul .list-li {
      box-shadow: 0px 0px 13px 0px rgba(127, 127, 127, 0.14);
      border-radius: 6px;
      padding: 22px 20px 27px 19px;
      display: inline-block;
      width: calc((100% / 5) - 58px);
      margin-right: 23px;
      margin-bottom: 22px;

      &:nth-child(5n) {
        margin-right: 0;
      }

      .list-li-logo {
        width: 175px;
        height: 175px;
        border: 1px solid #ECECEC;
        border-radius: 10px;
        margin-bottom: 20px;
      }

      .list-li-name {
        font-size: 16px;
        color: #383838;
        padding: 10px 0;
        text-align: center;
        position: relative;

        &::before,
        &::after {
          content: ' ';
          display: block;
          position: absolute;
          width: 15px;
          height: 15px;
          border: 1px solid #e2e2e2;
        }

        &::before {
          top: 0;
          left: 0;
          border-right: 0;
          border-bottom: 0;
        }

        &::after {
          bottom: 0;
          right: 0;
          border-left: 0;
          border-top: 0;
        }


      }
    }

    @media screen and (max-width: 1250px) {
      .departmental-list {
        width: 990px;
        margin: 36px auto 68px;
      }

      .departmental-title {
        padding: 43px 0 80px;
        margin-bottom: 33px;
      }

      .departmental-title>span {
        padding: 43px 5px 80px;
      }

      .departmental-title::after {
        width: 427px;
        height: 23px;
        top: 26px;
      }

      .list-ul .list-li {
        border-radius: 5px;
        padding: 18px 19px 22px 20px;
        width: calc((100% / 5) - 54px);
        margin-right: 18px;
        margin-bottom: 22px;

        .list-li-logo {
          width: 144px;
          height: 144px;
          border-radius: 8px;
          margin-bottom: 17px;
        }

        .list-li-name {
          font-size: 13px;
          padding: 10px 0;

          &::before,
          &::after {
            width: 13px;
            height: 13px;
          }
        }
      }
    }
  }
</style>